import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { closeModal } from '../../actions/modalAction';
import PurchaseBookSearch from '../finances/PurchaseBookSearch';
//import * as actions from '../../actions/companysAction';
const actions = { closeModal };

class SearchPurchaseBookModal extends Component {
  render() {
    return (
      <Modal size="small" 
      open={true} onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
<Modal.Content className='border'>
          <Modal.Description>
            <PurchaseBookSearch />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(SearchPurchaseBookModal);
